export type StepperPosition = 'top' | 'left' | 'none'

// Desktop : le stepper latéral n'existe qu'en position « left » ; en « top », la barre de
// progression passe au-dessus du formulaire et les questions prennent toute la largeur.
export const showSideStepper = (position: StepperPosition) => position === 'left'

export const showTopProgressBar = (position: StepperPosition) => position === 'top'

export const getWidthStepper = (position: StepperPosition) => (position === 'left' ? 5 : undefined)

// Desktop : le bloc des questions est centré verticalement dans la zone entre
// header et footer (Container en colonne flex avec hauteur minimale, Row aux marges verticales
// automatiques). La configuration du tunnel peut le désactiver ; absente = centré en desktop.
// Le mobile n'est jamais centré.
const shouldCenterVertically = (isDesktop: boolean, centering?: boolean) =>
  isDesktop && (centering ?? true)

export const getContentContainerStyle = (isDesktop: boolean, centering?: boolean) =>
  shouldCenterVertically(isDesktop, centering)
    ? { display: 'flex', flexDirection: 'column' as const, minHeight: '58vh' }
    : undefined

export const getContentRowStyle = (isDesktop: boolean, centering?: boolean) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  ...(shouldCenterVertically(isDesktop, centering)
    ? { marginTop: 'auto', marginBottom: 'auto' }
    : {}),
})
